export const GET_SEARCHSTORE_START = 'GET_SEARCHSTORE_START';
export const GET_SEARCHSTORE_SUCCESS = 'GET_SEARCHSTORE_SUCCESS';
export const GET_SEARCHSTORE_ERROR = 'GET_SEARCHSTORE_ERROR';
export const GET_SEARCHSTORE_END = 'GET_SEARCHSTORE_END';
export const GET_SEARCHSTORE_CLEAR = 'GET_SEARCHSTORE_CLEAR';
